import { defineStore } from 'pinia';
import { ls } from '@/plugins/vue-ls.ts';
import initialState from './state.js';

export const useLayoutStore = defineStore('layout', {
    state: () => ({
        ...initialState,
        navLocked: ls.get('navLocked', false),
    }),
    getters: {
        bodySpacingTop: (state) => state.bodyMarginTop + state.bodyPaddingTop,
    },
    actions: {
        setActiveSidebar(value) {
            this.activeSidebar = value;
        },

        setBodyMarginTop(value) {
            this.bodyMarginTop = parseInt(value || 0, 10);
        },

        setBodyPaddingTop(value) {
            this.bodyPaddingTop = parseInt(value || 0, 10);
        },

        setHeaderHeight(value) {
            this.headerHeight = parseInt(value || 0, 10);
        },

        setNavExpanded(value) {
            this.navExpanded = value;
        },

        setNavLocked(value) {
            this.navLocked = value;

            ls.set('navLocked', value);
        },
    },
});
